import React from 'react';
import { IconAttachment, IconUp, IconDown } from 'components/Icons';

import './TransactionsTableTableHeader.scss';
import { useTransactionsTableContext } from '../../Chart/context/TransactionsTableContext';

const TransactionsTableTableHeader: React.FC = () => {
  const { reportType, sortKey, sortDir, setSortKey, setSortDir } = useTransactionsTableContext();

  const handleSort = (key: string) => {
    if (sortKey === key) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
  };

  const getSortIcon = (key: string) => {
    if (sortKey !== key) return null;
    return sortDir === 'asc' ? <IconUp /> : <IconDown />;
  };

  return (
    <thead className="transactions-table-header" data-type={reportType}>
      <tr className="transactions-table-header-row">
        <th className={'transactions-table-header-item date sortable'} onClick={() => handleSort('date')}>
          DATE {getSortIcon('date')}
        </th>
        <th className={'transactions-table-header-item type text-left sortable'} onClick={() => handleSort('type')}>
          TYPE {getSortIcon('type')}
        </th>
        <th
          className={'transactions-table-header-item reference text-left sortable'}
          onClick={() => handleSort('reference')}
        >
          REFERENCE {getSortIcon('reference')}
        </th>
        <th className={'transactions-table-header-item sortable'} onClick={() => handleSort('name')}>
          NAME / MEMO {getSortIcon('name')}
        </th>
        <th className={'transactions-table-header-item'}>
          <IconAttachment />
        </th>

        {reportType === 'AP Aging' && (
          <th className={'transactions-table-header-item text-left sortable'} onClick={() => handleSort('dueDate')}>
            DUE DATE {getSortIcon('dueDate')}
          </th>
        )}
        <th className={'transactions-table-header-item text-right sortable'} onClick={() => handleSort('amount')}>
          AMOUNT {getSortIcon('amount')}
        </th>
        {reportType === 'AP Aging' && (
          <th className={'transactions-table-header-item text-right sortable'} onClick={() => handleSort('balance')}>
            BALANCE {getSortIcon('balance')}
          </th>
        )}
        <th className={'transactions-table-header-item'} width="33px"></th>
      </tr>
    </thead>
  );
};

export default TransactionsTableTableHeader;
